import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../_metronic/helpers'
import {Model, QueryResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const PROP_URL = `${API_URL}/SurveyApplication`
const PROP_URL2 = `${API_URL}/Custom/CreateSurveyApplicationCourseOutcome`
const PROP_URL3 = `${API_URL}/Custom/CreateSurveyApplicationOrganizationOutcome`
const PROP_URL4 = `${API_URL}/SurveyApplicationOrganizationEducationPurpose`
const PROP_URL5 = `${API_URL}/Custom/IsSurveyApplicationCourseOutcomeAnswered`
const PROP_URL6 = `${API_URL}/Custom/IsSurveyApplicationOrganizationOutcomeAnswered`
const PROP_URL7 = `${API_URL}/Custom/IsSurveyApplicationOrgEducationPurposeAnswered`
const PROP_URL8 = `${API_URL}/Custom/UpdateSurveyApplication`
const PROP_URL9 = `${API_URL}/Custom/CreateSurveyApplication`

function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}
const getSurveyApplication = (
  query: string,
  select?: string,
  modelstoinclude?: string
): Promise<QueryResponse> => {
  const qis = query.split('&')
  let newq: Array<string> = []
  qis.map((q) => {
    if (q.startsWith('filter') && q.slice(-1) != '=') {
      if (q.includes('_id')) {
        const aq = capitalizeFirstLetter(
          q.replace('_id', 'Id').replace('filter_', '').replace('=', '*')
        )
        //console.log(aq)
        newq.push(aq)
      } else if (q.includes('strt') && !q.includes(' ')) {
        const aq =
          '(Date)' +
          capitalizeFirstLetter(
            q.replace('strt', '').replace('filter_', '').replaceAll('-', '.').replace('=', '>')
          )
        //console.log(aq)
        newq.push(aq)
      } else if (q.includes('ndnd') && !q.includes(' ')) {
        const aq =
          '(Date)' +
          capitalizeFirstLetter(
            q.replace('ndnd', '').replace('filter_', '').replaceAll('-', '.').replace('=', '<')
          )
        //console.log(aq)
        newq.push(aq)
      } else if (q.includes('String')) {
        const aq = capitalizeFirstLetter(
          q.replace('String', '').replace('filter_', '').replace('=', '_')
        )
        //console.log(aq)
        newq.push(aq)
      } else if (q.includes('stNMB')) {
        const aq = capitalizeFirstLetter(
          q.replace('stNMB', '').replace('filter_', '').replace('=', '>')
        )
        //console.log(aq)
        newq.push(aq)
      } else if (q.includes('enNMB')) {
        const aq = capitalizeFirstLetter(
          q.replace('enNMB', '').replace('filter_', '').replace('=', '<')
        )
        //console.log(aq)
        newq.push(aq)
      } else if (q.includes('BL')) {
        const aq = capitalizeFirstLetter(
          q.replace('BL', '').replace('filter_', '').replace('=', '*')
        )
        //console.log(aq)
        newq.push(aq)
      }
    }
  })
  const newqstring = newq.filter((f) => f).join('|')

  let mti = ''
  if (modelstoinclude != undefined && modelstoinclude != '') {
    mti = '&modelstoinclude=' + modelstoinclude
  }
  let sti = ''
  if (select != undefined && select != '') {
    sti = '&select=' + select
  }

  return axios
    .get(`${PROP_URL}/getAll/${newqstring}?${query}${mti}${sti}`)
    .then((d: AxiosResponse<QueryResponse>) => d.data)
}

const listSurveyApplication = async (select?: string, modelstoinclude?: string): Promise<any> => {
  let mti = ''
  if (modelstoinclude != undefined) {
    mti = '&modelstoinclude=' + modelstoinclude
  }
  return await axios
    .get(`${PROP_URL}/getAll?page=1&items_per_page=99999${mti}&select=${select}`)
    .then((res: AxiosResponse) => {
      return res.data
    })
}

const getSurveyApplicationById = (id: any): Promise<Model | undefined> => {
  return axios
    .get(`${PROP_URL}/${id}`)
    .then((response: AxiosResponse<Response<Model>>) => response.data)
    .then((response: Response<Model>) => response as any)
}

const createSurveyApplication = (prop: Model): Promise<Model | undefined> => {
  return axios
    .put(PROP_URL, prop)
    .then((response: AxiosResponse<Response<Model>>) => response.data)
    .then((response: Response<Model>) => response.data)
}

const createSurveyApplicationCourseOutcome = (prop: any): Promise<any | undefined> => {
  return axios
    .put(PROP_URL2, prop)
    .then((response: any) => response)
    .then((response: any) => response)
}

const createSurveyApplicationOrganizationOutcome = (prop: any): Promise<any | undefined> => {
  return axios
    .put(PROP_URL3, prop)
    .then((response: any) => response)
    .then((response: any) => response)
}

const createSurveyApplicationOrganizationEducationPurpose = (
  prop: any
): Promise<any | undefined> => {
  return axios
    .put(PROP_URL4, prop)
    .then((response: any) => response)
    .then((response: any) => response)
}

const updateSurveyApplication = (prop: Model): Promise<any | undefined> => {
  return axios
    .post(`${PROP_URL}/${prop.id}`, prop)
    .then((response: AxiosResponse<Response<any>>) => response)
    .then((response: Response<any>) => response)
}

const updateCustomSurveyApplication = (prop: Model): Promise<any | undefined> => {
    return axios
        .post(`${PROP_URL8}`, prop)
        .then((response: any) => response)
        .then((response: any) => response)
}

const IsAnsweredSurveyAppCourseOutcome = (id: any): Promise<any | undefined> => {
  return axios
    .get(`${PROP_URL5}?surveyApplicationId=${id}`)
    .then((response: any) => response)
    .then((response: any) => response)
}
const IsAnsweredSurveyAppOrganizationOutcome = (id: any): Promise<any | undefined> => {
  return axios
    .get(`${PROP_URL6}?surveyApplicationId=${id}`)
    .then((response: any) => response)
    .then((response: any) => response)
}
const IsAnsweredSurveyAppEducationOutcome = (id: any): Promise<any | undefined> => {
  return axios
    .get(`${PROP_URL7}?surveyApplicationId=${id}`)
    .then((response: any) => response)
    .then((response: any) => response)
}

const createCustomSurveyApplication = (
    prop: any
): Promise<any | undefined> => {
    return axios
        .put(PROP_URL9, prop)
        .then((response: any) => response)
        .then((response: any) => response)
}

const deleteSurveyApplication = (propId: ID): Promise<void> => {
  return axios.delete(`${PROP_URL}/${propId}`).then(() => {})
}

const deleteSelectedSurveyApplication = (propIds: Array<ID>): Promise<void> => {
  const requests = propIds.map((id) => axios.delete(`${PROP_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {
  getSurveyApplication,
  deleteSurveyApplication,
  deleteSelectedSurveyApplication,
  getSurveyApplicationById,
  createSurveyApplication,
  updateSurveyApplication,
  listSurveyApplication,
  createSurveyApplicationCourseOutcome,
  createSurveyApplicationOrganizationOutcome,
  createSurveyApplicationOrganizationEducationPurpose,
  IsAnsweredSurveyAppCourseOutcome,
    IsAnsweredSurveyAppOrganizationOutcome,
    IsAnsweredSurveyAppEducationOutcome, updateCustomSurveyApplication, createCustomSurveyApplication,
}
